module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fechamento-multa-sla"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Meses")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "meses alinhar-conteudo fonte-tabela"
    }, [_c('strong', [_vm._v(_vm._s(item.mes.sigla))])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Valor da multa ")]), _vm._v(" "), _vm._l((_vm.valorMultas), function(multa) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "value": multa.moeda,
        "readonly": ""
      }
    }, 'money', _vm.money, false))], 1)
  })], 2), _vm._v(" "), (this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4) ? _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Valor da glosa")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "value": item.moeda,
        "readonly": ""
      }
    }, 'money', _vm.money, false))], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _vm._l((_vm.totalMultaGlosa), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "value": item.moeda,
        "readonly": ""
      }
    }, 'money', _vm.money, false))], 1)
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Fechamento")]), _vm._v(" "), _vm._l((_vm.fechamentoMultaGlosa), function(fechamentoMes) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [(!fechamentoMes.envio_confirmado) ? _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data-toggle": "listarGlosas"
      },
      on: {
        "click": function($event) {
          return _vm.exibirModalFechamentoMultaSla(fechamentoMes, 'NOVO')
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.statusFechamento.enviar) + "\n              ")])]) : _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data-toggle": "listarGlosas"
      },
      on: {
        "click": function($event) {
          return _vm.exibirModalFechamentoMultaSla(fechamentoMes, 'EXIBIR')
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.statusFechamento.enviado) + "\n              ")])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "numero-item bg-color-extremidades alinhar-conteudo fonte-tabela",
    attrs: {
      "rowspan": "15"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "descricao-sla bg-color-extremidades fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("Resumo mensal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "detalhe-descricao fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_c('strong', [_vm._v("Fechamento mensal multa / sla")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ec0bde2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sla/table/TableFechamentoMultaGlosa.vue
// module id = 1004
// module chunks = 1